import { createSlice } from '@reduxjs/toolkit';

const registrationSlice = createSlice({
  name: 'registration',
  initialState: {
    headerTitle: 'Dashboard'
  },
  reducers: {
    setHeaderTitle: (state, action) => {
      state.headerTitle = action.payload;
    }
  }
});

export const { setHeaderTitle } = registrationSlice.actions;

export default registrationSlice.reducer;
